import Vue from 'vue';

export interface Props {
  vid?: string;
  value?: unknown;
  label: string;
  rules?: Record<string, unknown>;
}

const ValidatableMixin = Vue.extend({
  name: 'ValidatableMixin',
  props: {
    vid: {
      type: String,
      default: undefined,
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: undefined,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    normalizedName(): string {
      return this.label.toLowerCase();
    },
  },
});

export default ValidatableMixin;
